<i18n>
{
  "en": {
    "title": "Employee Growth & Sustainability 2017-2018",
    "description": "We invest in our employees as lifelong learners, supporting them with educational opportunities from Worldwide Learning Week to annual training hours and more. We foster their professional development, and that of tomorrow’s workforce with the Go Green in the City sustainable development program. Read about our learning lifestyle and environment.",
    "ourPeople": {
      "section": "Our people",
      "title": "Our Investment for Growth",
      "investment": {
        "txt1": {
          "title": "Our learning lifestyle",
          "para1": "The spirit of lifelong learning is powerful at Schneider Electric. Globally, our employees are empowered to develop to his or her fullest potential, through equal opportunities for ongoing development. Beyond that, employees are actively tasked with completing seven hours of logged training annually. We enjoy a unique learning culture where we encourage employees to take an active role in owning and advancing their career. Through academies, Leadership Development Centers, internal learning tools, and more, employees can sharpen their skills and broaden their horizons. We emphasize proactive thinking about career development, beyond entities and across geographies."
        },
        "txtMedia1": {
          "title": "Worldwide Learning Week",
          "para1": "Marking its fourth year, Learning Week is a major contributor to our learning culture strategy. It gives employees around the world the chance to connect, train, and share knowledge through educational events including:",
          "listItem1": "Webinars and workshops on key subjects",
          "listItem2": "Collective e-learning",
          "listItem3": "Marketplace",
          "listItem4": "Roundtables with leaders",
          "listItem5": "Games, contests, and more"
        },
        "snapshot1": {
          "title": "Global recognition",
          "cell1": {
            "title": ">50,000",
            "para": "employees participated"
          },
          "cell2": {
            "title": "75%",
            "para": "of respondents were satisfied with Learning Week"
          },
          "cell3": {
            "title": "78%",
            "para": "are likely to recommend Learning Week to a friend or colleague"
          },
          "cell4": {
            "title": "95%",
            "para": "believe Learning Week should continue to be organized in the future"
          }
        },
        "txt2": {
          "title": "Global Learning Days",
          "para1": "In addition to Worldwide Learning Week, we also introduced the first-ever global Learning Days in 2017, with learning offered on specific business topics:",
          "listItem1": "Schneider Electric's Products and Services",
          "listItem2": "Customer Centricity",
          "listItem3": "Digitization and IoT "
        },
        "statement": "Learning Days will continue to be offered in 2018 to maintain the focus on lifelong learning at Schneider Electric.",
        "barometer1": {
          "h2": "2015 – 2017 Planet <span class='t-nowrap'>& Society</span> barometer achievement",
          "cta": "See the full results",
          "indicator": {
            "title": "Health & Equity",
            "stat": "92%",
            "body": "one-day training for every employee, every year"
          }
        },
        "txt3": {
          "title": "Go Green in the City",
          "para1-1": "We also foster the curiosity and capabilities of tomorrow’s workforce through programs like Go Green in the City &mdash; an annual international business case challenge for university business and engineering students around the world to find innovative solutions for energy management and automation. Participants include individual students in teams of two, of which at least one team member is female, confirming Schneider Electric’s commitment to ",
          "para1-linkText": "Diversity and Inclusion.",
          "para1-2": ""
        },
        "imageFull": "2017 winners: Raja Jain and Nimisha Gupta from the Indian Institute of Technology Roorkee won Go Green in the City 2017, for the idea of using the ancient Indian technology of earthen pots to develop a modern-day cooling system.",
        "snapshot2": {
          "title": "Go Green in the City 2017 Accomplishments",
          "cell1": {
            "title": "19,772",
            "para": "participants in 2017"
          },
          "cell2": {
            "title": "60,000+",
            "para": "participants in total (2011 – 2017)"
          },
          "cell3": {
            "title": "180",
            "para": "countries in 2017, expanded from 8 countries in 2011"
          },
          "cell4": {
            "title": "58%",
            "para": "of 2017 participants were female"
          }
        },
        "txt4": {
          "title": "World Employee Share Ownership Plan",
          "para1": "Part of our Rewards program, the World Employee Share Ownership Plan (WESOP) affords employees the chance to become company shareholders, and to be inspired by the benefits of our collective success. The 2017 program was unveiled in 32 countries, offered to approximately 120,000 employees. Schneider is one of few global companies to offer this type of benefit to its employees each year."
        },
        "vid1": {
          "title": "Learning at<br> Schneider Electric",
          "desc": "Tina Mylon, <br>SVP Talent and Diversity, <br>Schneider Electric"
        }
      }
    }
  },
  "fr": {
    "title": "Employee Growth & Sustainability 2017-2018",
    "description": "We invest in our employees as lifelong learners, supporting them with educational opportunities from Worldwide Learning Week to annual training hours and more. We foster their professional development, and that of tomorrow’s workforce with the Go Green in the City sustainable development program. Read about our learning lifestyle and environment.",
    "ourPeople": {
      "section": "Nos Collaborateurs",
      "title": "Notre Investissement pour la Croissance",
      "investment": {
        "txt1": {
          "title": "Notre vision de la formation",
          "para1": "Le concept de formation continue est fortement ancré chez Schneider Electric. Partout dans le monde, nous donnons à nos collaborateurs les moyens de révéler leur potentiel, en leur garantissant une égalité des chances en matière de développement continu. Plus concrètement, nous leur fixons l’objectif de suivre sept heures de formation par an. Nous sommes fiers de cette culture de la formation qui constitue l'un de nos traits distinctifs, et en vertu de laquelle nous encourageons les collaborateurs à jouer un rôle actif dans la prise en main et l’avancement de leur carrière. Grâce, entre autres, à des centres de formation et de développement du leadership et des outils de formation internes, les collaborateurs peuvent perfectionner leurs connaissances et élargir leur horizon. Nous les poussons à réfléchir proactivement à leur évolution de carrière, y compris au-delà de leur entité ou de leur zone géographique."
        },
        "txtMedia1": {
          "title": "La semaine mondiale de la formation",
          "para1": "Pour la quatrième année consécutive, la semaine de la formation contribue fortement à la stratégie de notre culture de formation. Elle donne aux collaborateurs à travers le monde l’opportunité de se former et de partager des connaissances au cours de différentes activités :",
          "listItem1": "Webinaires et ateliers sur des thèmes clés",
          "listItem2": "Sessions collectives de e-learning",
          "listItem3": "Marketplace",
          "listItem4": "Tables rondes avec nos leaders",
          "listItem5": "Jeux, concours, etc."
        },
        "snapshot1": {
          "cell1": {
            "title": "Plus de 50 000",
            "para": "collaborateurs ont participé activement"
          },
          "cell2": {
            "title": "75%",
            "para": "des personnes interrogées se disent satisfaites de la semaine de la formation"
          },
          "cell3": {
            "title": "78%",
            "para": "sont susceptibles de la recommander à un ami ou à un collègue"
          },
          "cell4": {
            "title": "95%",
            "para": "pensent que cette expérience devrait être renouvelée"
          }
        },
        "txt2": {
          "title": "Journées mondiales de la formation",
          "para1": "En complément de la semaine mondiale de la formation, nous avons également lancé les premières journées mondiales de la formation en 2017, et proposé des formations sur différents sujets spécifiques à l’entreprise : ",
          "listItem1": "Schneider Electric, nos produits et services",
          "listItem2": "Orientation client",
          "listItem3": "Numérisation et IdO"
        },
        "statement": "Les journées de la formation seront de nouveau organisées en 2018 pour prolonger l’accent mis par Schneider Electric sur la formation continue.",
        "barometer1": {
          "h2": "Résultat du baromètre 2015 &mdash; 2017 Planète & Société",
          "cta": "Voir l’ensemble des résultats ",
          "indicator": {
            "title": "Santé & Équité",
            "stat": "92%",
            "body": "des collaborateurs bénéficient d'un jour de formation chaque année"
          }
        },
        "txt3": {
          "title": "Go Green in the City",
          "para1-1": "Nous stimulons également la curiosité et les aptitudes des collaborateurs de demain à travers des programmes comme Go Green in the City, un concours annuel international qui propose aux étudiants des universités et écoles de commerce et d’ingénieurs du monde entier des études de cas, avec pour enjeu de trouver des solutions innovantes en gestion durable de l'énergie et en automatismes. Les équipes sont des binômes qui doivent compter au moins une femme, preuve supplémentaire de l’engagement de Schneider Electric en faveur de la ",
          "para1-linkText": "diversité et de l’inclusion.",
          "para1-2": ""
        },
        "imageFull": "Lauréats 2017 : Raja Jain et Nimisha Gupta, de l’Institut de technologie de Roorkee, en Inde, ont remporté l'édition 2017 de Go Green in the City grâce à leur idée d’utiliser la technique indienne ancestrale des pots en terre pour développer un système de refroidissement moderne.",
        "snapshot2": {
          "title": "Go Green in the City 2017",
          "cell1": {
            "title": "19 772",
            "para": "participants en 2017"
          },
          "cell2": {
            "title": "Plus de 60 000",
            "para": "participants au total (2011-2017)"
          },
          "cell3": {
            "title": "180",
            "para": "pays ont participé en 2017,  8 pays en 2011"
          },
          "cell4": {
            "title": "58%",
            "para": "de femmes pour l'édition 2017"
          }
        },
        "txt4": {
          "title": "Plan d'actionnariat salarié",
          "para1": "Notre programme d'actionnariat salarié (WESOP) permet aux salariés de devenir actionnaires de l’entreprise et de récolter les fruits de notre réussite collective. Le plan  2017 a été déployé dans 32 pays, et proposé à quelques 120 000 collaborateurs. Schneider Electric est l’un des rares groupes internationaux à proposer ce type de programme à ses salariés chaque année."
        },
        "vid1": {
          "title": "La formation chez Schneider Electric",
          "desc": "Tina Mylon, <br>SVP Talents et Diversité, <br>Schneider Electric"
        }
      }
    }
  }
}
</i18n>
<template>
  <div>
    <Hero
      :loResSrc="require('@/assets/img/our-people/our-people-welcome-hero-lowres.jpg')"
      :hiResSrc="require('@/assets/img/our-people/our-people-our-investment-hero.jpg')"
      chapter="04"
      :section="$t('nav.OurPeople')"
      :title="$t('ourPeople.title')" />

    <section class="m-b-120 m-t-120">
      <YouTubeVideo class="m-b-80" videoId="x4rxvldUJms" :title="$t('ourPeople.investment.vid1.title')" :description="$t('ourPeople.investment.vid1.desc')" :preview="require('@/assets/img/thumbnails/SSDHighlightVideo_Tina_Still.jpg')" />

      <Txt>
        <h2 v-html="$t('ourPeople.investment.txt1.title')"></h2>
        <p id="lifelonglearning" v-html="$t('ourPeople.investment.txt1.para1')" class="m-0"></p>
      </Txt>
    </section>

    <hr>

    <section class="m-b-120 m-t-120">
      <TxtMedia>
        <h2 id="learningweek" class="m-b-45" slot="main-content" v-html="$t('ourPeople.investment.txtMedia1.title')"/>
        <p slot="main-content" v-html="$t('ourPeople.investment.txtMedia1.para1')" />
        <ul slot="main-content">
          <li v-html="$t('ourPeople.investment.txtMedia1.listItem1')"></li>
          <li v-html="$t('ourPeople.investment.txtMedia1.listItem2')"></li>
          <li v-html="$t('ourPeople.investment.txtMedia1.listItem3')"></li>
          <li v-html="$t('ourPeople.investment.txtMedia1.listItem4')"></li>
          <li v-html="$t('ourPeople.investment.txtMedia1.listItem5')"></li>
        </ul>
        <img slot="sidebar" src="@/assets/img/our-people/our-people-our-investment-worldwide.jpg" />
      </TxtMedia>

      <Snapshot>
        <SnapshotCard>
          <h4 class="t-green-light" v-html="$t('ourPeople.investment.snapshot1.cell1.title')"></h4>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('ourPeople.investment.snapshot1.cell1.para')"></p>
        </SnapshotCard>

        <SnapshotCard class="t-white" bgc="#3dcd58">
          <h4 class="" v-html="$t('ourPeople.investment.snapshot1.cell2.title')"></h4>
          <div class="t-hr t-hr--white"></div>
          <p class="t-chartbody" v-html="$t('ourPeople.investment.snapshot1.cell2.para')"></p>
        </SnapshotCard>

        <SnapshotCard>
          <h4 class="t-green-light" v-html="$t('ourPeople.investment.snapshot1.cell3.title')"></h4>
          <div class="t-hr"></div>
          <p v-html="$t('ourPeople.investment.snapshot1.cell3.para')" class="t-chartbody"></p>
        </SnapshotCard>

        <SnapshotCard class="t-white" bgc="#626469">
          <h4 class="" v-html="$t('ourPeople.investment.snapshot1.cell4.title')"></h4>
          <div class="t-hr t-hr--white"></div>
          <p v-html="$t('ourPeople.investment.snapshot1.cell4.para')" class="t-chartbody"></p>
        </SnapshotCard>
      </Snapshot>
    </section>

    <section class="m-b-120 m-t-120 l-section-pad l-bg-white">
      <TxtMedia class="m-b-32">
        <div slot="main-content">
          <h2 id="learningdays" v-html="$t('ourPeople.investment.txt2.title')"></h2>
          <p v-html="$t('ourPeople.investment.txt2.para1')" class="m-0"></p>
          <ol>
            <li v-html="$t('ourPeople.investment.txt2.listItem1')"></li>
            <li v-html="$t('ourPeople.investment.txt2.listItem2')"></li>
            <li v-html="$t('ourPeople.investment.txt2.listItem3')"></li>
          </ol>
        </div>
        <img slot="sidebar" :src="require('@/assets/img/our-people/P1070348.jpg')" alt="">
      </TxtMedia>

      <Statement>
        <h3 v-html="$t('ourPeople.investment.statement')"></h3>
      </Statement>
    </section>

    <section class="m-b-120 m-t-120">
      <Barometer>
        <h2 class="t-grey" slot="copy" v-html="$t('ourPeople.investment.barometer1.h2')"></h2>
        <CTA slot="copy" href="/static/PSBarometer-Q42017_results.pdf" :buttonText="$t('ourPeople.investment.barometer1.cta')" target="_blank" />
        <BarometerIndicator class="col-xs-18" color="#42b4e6"
          :title="$t('ourPeople.investment.barometer1.indicator.title')" :stat="$t('ourPeople.investment.barometer1.indicator.stat')"
          :body="$t('ourPeople.investment.barometer1.indicator.body')"/>
      </Barometer>
    </section>

    <section class="m-b-120 m-t-120 l-section-pad l-bg-white">
      <Txt class="m-b-32">
        <h2 id="gogreen" v-html="$t('ourPeople.investment.txt3.title')"></h2>
        <p class="m-0">
          <span v-html="$t('ourPeople.investment.txt3.para1-1')"></span>
          <router-link class="t-green-light" v-html="$t('ourPeople.investment.txt3.para1-linkText')" :to="{name: 'OurPeople_LiveLivesBetter', params: {lang: $route.params.lang }, hash: '#diversity-means-value'}"></router-link>
        </p>
      </Txt>

      <ImageFull :caption="$t('ourPeople.investment.imageFull')">
        <img :src="require('@/assets/img/our-people/our-people-our-investment-full-img.jpg')" alt=""/>
      </ImageFull>
    </section>

    <section class="m-b-120 m-t-120">
      <Snapshot>
        <div slot="above">
          <h2 v-html="$t('ourPeople.investment.snapshot2.title')"></h2>
        </div>
        <SnapshotCard class="t-white" :bgimg="require('@/assets/img/our-people/our-people-our-investment-snapshot-cell-1A.jpg')">
          <h4 v-html="$t('ourPeople.investment.snapshot2.cell1.title')"></h4>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('ourPeople.investment.snapshot2.cell1.para')"></p>
        </SnapshotCard>

        <SnapshotCard>
          <h4 class="t-green-light" v-html="$t('ourPeople.investment.snapshot2.cell2.title')"></h4>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('ourPeople.investment.snapshot2.cell2.para')"></p>
        </SnapshotCard>

        <SnapshotCard class="t-white" bgc="#3dcd58">
          <h4 class="" v-html="$t('ourPeople.investment.snapshot2.cell3.title')"></h4>
          <div class="t-hr t-hr--white"></div>
          <p class="t-chartbody" v-html="$t('ourPeople.investment.snapshot2.cell3.para')"></p>
        </SnapshotCard>

        <SnapshotCard>
          <h4 class="t-green-light" v-html="$t('ourPeople.investment.snapshot2.cell4.title')"></h4>
          <div class="t-hr"></div>
          <p v-html="$t('ourPeople.investment.snapshot2.cell4.para')" class="t-chartbody"></p>
        </SnapshotCard>
      </Snapshot>
    </section>

    <section class="m-b-50 m-t-120 l-section-pad l-bg-white">
      <Txt>
        <h2 v-html="$t('ourPeople.investment.txt4.title')"></h2>
        <p id="wesop" v-html="$t('ourPeople.investment.txt4.para1')" class="m-0"></p>
      </Txt>
    </section>

    <div class="l-content">
      <FooterNav
        nextRoute="OurPeople_LiveLivesBetter"
        prevRoute="OurPeople_CompanyPrograms" />
    </div>
  </div>
</template>
<script>

import Hero from '@/components/Hero'
import YouTubeVideo from '@/components/YouTubeVideo'
import Txt from '@/components/Txt'
import TxtMedia from '@/components/TxtMedia'
import Snapshot from '@/components/Snapshot'
import SnapshotCard from '@/components/SnapshotCard'
import Statement from '@/components/Statement'
import Barometer from '@/components/Barometer'
import BarometerIndicator from '@/components/BarometerIndicator'
import ImageFull from '@/components/ImageFull'
import FooterNav from '@/components/FooterNav'
import CTA from '@/components/CTA'

export default {
  name: 'OurPeople_InvestmentForGrowth',
  metaInfo () {
    return {
      title: this.$t('title'),
      meta: [
        { name: 'description', content: this.$t('description') }
      ]
    }
  },
  mounted () {
    if (window.location.hash.substr(1).length > 0) {
      this.$nextTick(function () {
        document.getElementById(window.location.hash.substr(1)).scrollIntoView()
      })
    }
  },
  components: {
    Hero,
    YouTubeVideo,
    Txt,
    TxtMedia,
    Snapshot,
    SnapshotCard,
    Statement,
    Barometer,
    BarometerIndicator,
    ImageFull,
    FooterNav,
    CTA
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/our-people/investment-for-growth.vue